/**
 * Messaging Service - API calls for messaging system
 */

/**
 * Get all conversations for current user
 */
export const fetchConversations = async ({ BeURL }) => {
    try {
        const response = await fetch(`${BeURL}/messages/conversations`, {
            credentials: "include",
            method: "GET",
            headers: { "Content-Type": "application/json" }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching conversations:", error);
        return { success: false, message: "Error fetching conversations", error };
    }
};

/**
 * Get messages in a conversation
 */
export const fetchConversationMessages = async ({ BeURL, conversationId, page = 1, limit = 50 }) => {
    try {
        const response = await fetch(
            `${BeURL}/messages/conversation/${conversationId}?page=${page}&limit=${limit}`,
            {
                credentials: "include",
                method: "GET",
                headers: { "Content-Type": "application/json" }
            }
        );
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching conversation messages:", error);
        return { success: false, message: "Error fetching messages", error };
    }
};

/**
 * Start new conversation
 */
export const startConversation = async ({ BeURL, courseId, otherUserId }) => {
    try {
        const response = await fetch(`${BeURL}/messages/start-conversation`, {
            credentials: "include",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ courseId, otherUserId })
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error starting conversation:", error);
        return { success: false, message: "Error starting conversation", error };
    }
};

/**
 * Send a message with optional image
 */
export const sendMessage = async ({ BeURL, conversationId, content, imageData = null }) => {
    try {
        const payload = {
            conversationId,
            content: content || '', // Allow empty content if image is provided
            ...(imageData && { imageData })
        };

        const response = await fetch(`${BeURL}/messages/send`, {
            credentials: "include",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload)
        });

        // Check if response is OK before parsing
        if (!response.ok) {
            const errorText = await response.text();
            console.error('Server error response:', errorText);

            // Provide user-friendly error message for specific status codes
            if (response.status === 413) {
                return {
                    success: false,
                    message: 'Image file is too large. Please select a smaller image or compress it.'
                };
            }

            return {
                success: false,
                message: `Server error: ${response.status} ${response.statusText}`
            };
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error sending message:", error);
        return { success: false, message: "Error sending message", error };
    }
};

/**
 * Mark message as read
 */
export const markMessageAsRead = async ({ BeURL, messageId }) => {
    try {
        const response = await fetch(`${BeURL}/messages/${messageId}/read`, {
            credentials: "include",
            method: "PUT",
            headers: { "Content-Type": "application/json" }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error marking message as read:", error);
        return { success: false, message: "Error updating message", error };
    }
};

/**
 * Get unread message count
 */
export const getUnreadCount = async ({ BeURL }) => {
    try {
        const response = await fetch(`${BeURL}/messages/unread-count`, {
            credentials: "include",
            method: "GET",
            headers: { "Content-Type": "application/json" }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching unread count:", error);
        return { success: false, message: "Error fetching unread count", error };
    }
};
